import React from "react";
import Label from "@/components/form/Label";
import Dropdown, { DropdownOption } from "./Dropdown";

interface DropdownFieldProps {
  id: string;
  name: string;
  value: string;
  onChange: (value: string) => void;
  options: DropdownOption[];
  /** ReactNode so a field can carry a scope chip beside its text (#3022). */
  label?: React.ReactNode;
  placeholder?: string;
  required?: boolean;
  error?: boolean | string;
  hint?: string;
  className?: string;
  disabled?: boolean;
}

const DropdownField: React.FC<DropdownFieldProps> = ({
  id,
  name,
  value,
  onChange,
  options,
  label,
  placeholder = "Select an option",
  required = false,
  error = false,
  hint,
  className = "",
  disabled = false,
}) => {
  return (
    <div className={className}>
      {label && (
        <Label id={`${id}-label`} htmlFor={id} required={required} className="mb-2">
          {label}
        </Label>
      )}
      <Dropdown
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        options={options}
        placeholder={placeholder}
        required={required}
        error={typeof error === 'string' ? error : ""}
        disabled={disabled}
        ariaLabelledBy={label ? `${id}-label` : undefined}
      />
      {hint && !error && (
        <p className="mt-1.5 text-xs text-gray-500 dark:text-gray-400">{hint}</p>
      )}
    </div>
  );
};

export default DropdownField; 